import React from 'react'

export default function LeftContent ({ children }) {
  return (
    <div className={'mtt-loan-modal__left-content'}>
      {children}
    </div>
  )
}
